/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_TitleInputs */

const en_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Issues`)
};

const fr_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les incidents`)
};

const de_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportprobleme`)
};

const it_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemi di esportazione`)
};

const ru_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы экспорта`)
};

const es_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemas de exportación`)
};

const zh_cn2_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口问题`)
};

const ja_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出に関する問題`)
};

const hi_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात संबंधी मुद्दे`)
};

const pt_pt2_manual_qc_export_title = /** @type {(inputs: Manual_Qc_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questões de exportação`)
};

/**
* | output |
* | --- |
* | "Export Issues" |
*
* @param {Manual_Qc_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_title = /** @type {((inputs?: Manual_Qc_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_title(inputs)
	if (locale === "de") return de_manual_qc_export_title(inputs)
	if (locale === "it") return it_manual_qc_export_title(inputs)
	if (locale === "ru") return ru_manual_qc_export_title(inputs)
	if (locale === "es") return es_manual_qc_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_title(inputs)
	if (locale === "ja") return ja_manual_qc_export_title(inputs)
	if (locale === "hi") return hi_manual_qc_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_title(inputs)
	return en_manual_qc_export_title(inputs)
});